// const { Dialog } = require('./modal');

import { validate } from '../vendor/validate';
import { Recaptcha } from './recaptcha';

// remove error message from dropzone fields
const removeErrorMsg = (elem) => {
    if (elem.classList.contains('error')) {
        elem.classList.remove('error');
        const errorEl = elem.querySelector('.error-message');
        elem.removeChild(errorEl);
    }
};

const hasHiddenStyle = (node) => {
    if (!node) return false;

    const style = window.getComputedStyle(node);
    return style.display === 'none' || style.visibility === 'hidden';
};

const isHidden = (el) => {
    const formGroup = el.closest('.form-group');
    const formSection = el.closest('.form-section');

    return hasHiddenStyle(el) || hasHiddenStyle(formGroup) || hasHiddenStyle(formSection);
};

const showElement = (elem) => {
    if (elem.getAttribute('aria-hidden') !== 'false') {
        elem.removeAttribute('hidden');
        elem.setAttribute('aria-hidden', 'false');
    }
};

const hiddenElement = (elem) => {
    if (elem.getAttribute('aria-hidden') !== 'true') {
        elem.hidden = true;
        elem.setAttribute('aria-hidden', 'true');
    }
};

const initValidate = (form) => {
    const inputEls = form.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
    for (const inputEl of inputEls) {
        inputEl.addEventListener('blur', validate.inputHandler);
        inputEl.addEventListener('input', validate.inputHandler);
        inputEl.addEventListener('change', validate.inputHandler);
    }

    const textareaEls = form.querySelectorAll('textarea[required]');
    for (const textareaEl of textareaEls) {
        textareaEl.addEventListener('blur', validate.inputHandler);
        textareaEl.addEventListener('input', validate.inputHandler);
        textareaEl.addEventListener('change', validate.inputHandler);
    }

    const selectEls = form.querySelectorAll('select[required]');
    for (const selectEl of selectEls) {
        selectEl.addEventListener('change', validate.inputHandler);
    }

    const controlEls = form.querySelectorAll('input[required][type="checkbox"]');
    for (const el of controlEls) {
        el.addEventListener('change', validate.inputHandler);
    }

    const radioEls = form.querySelectorAll('input[required][type="radio"]');
    for (const el of radioEls) {
        el.addEventListener('change', validate.inputHandler);
    }
};

const validateForm = (form) => {
    let formID = form.getAttribute('id');
    let requiredFields = document.querySelectorAll('#' + formID + ' [required]');

    let hasErrors,
        formErrors = false;

    for (const reqField of requiredFields) {
        if (!isHidden(reqField)) {
            const error = validate.hasError(reqField);

            if (error) {
                validate.showError(reqField, error);
                if (!hasErrors) {
                    hasErrors = reqField;
                }
            }
        }
    }

    // console.log(hasErrors);

    if (hasErrors) {
        hasErrors.focus();
        formErrors = true;
    }

    return !formErrors;
};

const validatingForms = document.querySelectorAll('.js-validate-form');

for (const formNode of validatingForms) {
    formNode.setAttribute('novalidate', 'true');
    initValidate(formNode);

    formNode.addEventListener('submit', function (event) {
        // event.preventDefault();

        const subBtn = formNode.querySelector('.js-submit-button');
        const subBtnValue = subBtn.value;
        subBtn.disabled = true;
        subBtn.value = 'Processing';

        const isFormValid = validateForm(formNode);

        if (isFormValid) {
            (new Recaptcha(formNode)).submitForm(event, () => {
                subBtn.disabled = false;
                subBtn.value = subBtnValue;
            });

            return true;
        } else {
            event.preventDefault();
            subBtn.disabled = false;
            subBtn.value = subBtnValue;

            return false;
        }
    });
}